import { useEffect } from 'react';
import { API_BASE_URL } from '../constants';

const useCharacterSelection = ({
    selectedCharacter,
    allCards,
    setCards,
    isRestoring,
    setSelectedCard,
    setStats,
    allStats,
    setAptitudes,
    allAptitudes,
    selectedCard,
    setSelectedStars,
    setCardSkills,
    setActiveSkills,
    setUniqueSkill,
    stats,
    selectedStars,
    setEditableStats
}) => {

    // Filter data when character changes
    useEffect(() => {
        if (selectedCharacter) {
            const charPersonajeId = selectedCharacter.Id_Personaje;
            const filteredCards = allCards.filter(c => c.Id_Personaje === charPersonajeId);
            setCards(filteredCards);

            if (filteredCards.length > 0) {
                // Only set default card if NOT restoring
                if (!isRestoring.current) {
                    setSelectedCard(filteredCards[0]);
                }
            } else {
                setSelectedCard(null);
            }

            setStats(allStats.filter(s => s.Id_Personaje === charPersonajeId));

            // REMOVED: Legacy aptitude setting. Now handled in the card effect.
        }
    }, [selectedCharacter, allCards, allStats, isRestoring, setCards, setSelectedCard, setStats]);

    // Update stars, stats AND APTITUDES when card changes
    useEffect(() => {
        const fetchCardSkills = async (cardId) => {
            try {
                const headers = {};
                // Interceptor handles Authorization
                const response = await fetch(`${API_BASE_URL}/card_skills/${cardId}`, { headers });
                if (response.ok) {
                    const data = await response.json();
                    setCardSkills(data);
                } else {
                    setCardSkills([]);
                }
            } catch (error) {
                console.error("Error fetching card skills:", error);
                setCardSkills([]);
            }
        };

        if (selectedCard) {
            if (!isRestoring.current) {
                setSelectedStars(selectedCard.stars_initial);

                // [NEW] Set Aptitudes specific to this Card
                // Uses card_id to find the exact match from the global list

                const cardAptitude = allAptitudes.find(a => {
                    // Check exact card match
                    // eslint-disable-next-line eqeqeq
                    if (a.card_id != null && a.card_id == selectedCard.card_id) return true;

                    // Fallback: If aptitude has NO card_id (stale cache), match by Character ID as best effort
                    // eslint-disable-next-line eqeqeq
                    if ((a.card_id === null || a.card_id === undefined) && a.Id_Personaje == selectedCard.Id_Personaje) return true;

                    return false;
                });

                // Fallback to empty object if not found (though it should exist if data is consistent)
                setAptitudes(cardAptitude || {});
            }
            // Fetch Card Skills
            fetchCardSkills(selectedCard.card_id);
        } else {
            setCardSkills([]);
            setActiveSkills([]);
            setUniqueSkill(null);
            // Optional: clear aptitudes if no card selected, or keep previous? 
            // Better to clear or set default to avoid confusion.
            // setAptitudes({}); // Uncomment if we want to clear aptitudes when no card is selected
        }
    }, [selectedCard, isRestoring, setSelectedStars, setCardSkills, setActiveSkills, setUniqueSkill, allAptitudes, setAptitudes]);

    // Update editableStats when stats or selection changes
    useEffect(() => {
        if (!isRestoring.current) {
            const currentStats = stats.find(s =>
                s.Estrellas === selectedStars &&
                (s.card_id === selectedCard?.card_id || (!s.card_id && !selectedCard?.card_id))
            ) || {};
            setEditableStats(currentStats);
        }
    }, [stats, selectedStars, selectedCard, isRestoring, setEditableStats]);
};

export default useCharacterSelection;
// Revisado: 2025-12-16
